.timeline {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
}

.creation {
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  gap: var(--pgm-sys-spacing-4);
  padding: var(--pgm-sys-spacing-6);
}

.creationIcon {
  color: var(--pgm-sys-color-secondary);
  flex-shrink: 0;
  font-size: 28px;
  line-height: 28px;
}

.creationTexts {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  min-width: 0;
}

.creationTitle {
  color: var(--pgm-sys-color-secondary);
  margin: 0;
}

.creationText {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
  white-space: pre-line;
}

.events {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-3);
  list-style: none;
  margin: 0;
  padding: 0;
}

.event {
  align-items: stretch;
  display: flex;
  gap: var(--pgm-sys-spacing-6);
  position: relative;
}

.event::before {
  background-color: var(--pgm-sys-color-outline-variant);
  content: "";
  height: calc(100% + var(--pgm-sys-spacing-3));
  left: 102px;
  position: absolute;
  top: 0;
  width: 4px;
}

.event:first-child::before {
  height: calc(100% + var(--pgm-sys-spacing-3) - 12px);
  top: 12px;
}

.event:last-child::before {
  height: 100%;
}

.event::after {
  background-color: var(--pgm-sys-color-outline);
  border-radius: 50%;
  content: "";
  height: 24px;
  left: 92px;
  position: absolute;
  top: 0;
  width: 24px;
}

.when {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: flex-start;
  text-align: right;
  width: 80px;
}

.date,
.year {
  color: var(--pgm-sys-color-on-surface);
}

.card {
  align-items: center;
  background-color: var(--pgm-sys-color-surface);
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  flex: 1 1 auto;
  gap: var(--pgm-sys-spacing-10);
  margin-left: var(--pgm-sys-spacing-6);
  min-width: 0;
  padding: var(--pgm-sys-spacing-2);
}

.photo {
  background-color: var(--pgm-sys-color-surface-container);
  border-radius: 12px;
  display: block;
  flex-shrink: 0;
  height: 100px;
  object-fit: cover;
  width: 110px;
}

.who {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
  min-width: 0;
}

.subrole,
.role {
  color: var(--pgm-sys-color-on-surface);
}

.person {
  color: var(--pgm-sys-color-secondary);
}

.until {
  align-items: center;
  background-color: var(--pgm-sys-color-surface-container-high);
  border-radius: 4px;
  color: var(--pgm-sys-color-on-surface);
  display: inline-flex;
  flex-shrink: 0;
  gap: var(--pgm-sys-spacing-2);
  padding: var(--pgm-sys-spacing-2) var(--pgm-sys-spacing-3);

  span {
    font-size: 20px;
    line-height: 20px;
  }
}

.untilCurrent {
  background-color: var(--pgm-sys-color-secondary);
  color: var(--pgm-sys-color-on-secondary);

  span {
    font-variation-settings: "FILL" 1;
  }
}

@media (max-width: 899.98px) {
  .event {
    flex-direction: column;
    gap: var(--pgm-sys-spacing-2);
  }

  .event::before,
  .event::after {
    display: none;
  }

  .when {
    flex-direction: row;
    gap: var(--pgm-sys-spacing-2);
    text-align: left;
    width: auto;
  }

  .card {
    align-items: flex-start;
    flex-direction: column;
    gap: var(--pgm-sys-spacing-4);
    margin-left: 0;
    padding: var(--pgm-sys-spacing-4);
  }
}
